import { useCallback, useMemo } from 'react';
import { readColorKeyOfRawCategory } from 'features/transactions/utils';
import useColors from 'hooks/useColors';
import { selectNormalizedCategories } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { defaultCategories } from '../constants';
export const isDefaultCategory = (id) => defaultCategories.includes(id);
export const useCategories = () => {
    const colors = useColors();
    return useMemo(() => ({
        shopping: {
            id: 'shopping',
            displayName: 'Shopping',
            color: colors.categories.shopping,
            emoji: '🛍',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        transport: {
            id: 'transport',
            displayName: 'Transport',
            color: colors.categories.transport,
            emoji: '🚗',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        groceries: {
            id: 'groceries',
            displayName: 'Groceries',
            color: colors.categories.groceries,
            emoji: '🛒',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        entertainment: {
            id: 'entertainment',
            displayName: 'Entertainment',
            color: colors.categories.entertainment,
            emoji: '🎷',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        cash: {
            id: 'cash',
            displayName: 'Cash',
            color: colors.categories.cash,
            emoji: '💵',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        eatingout: {
            id: 'eatingout',
            displayName: 'Eating out',
            color: colors.categories.eatOut,
            emoji: '🌯',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        holidays: {
            id: 'holidays',
            displayName: 'Holidays',
            color: colors.categories.holidays,
            emoji: '🏖',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        health: {
            id: 'health',
            displayName: 'Personal care',
            color: colors.categories.personalCare,
            emoji: '🚴‍♂️',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        housing: {
            id: 'housing',
            displayName: 'Housing',
            color: colors.categories.housing,
            emoji: '🏠',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        bills: {
            id: 'bills',
            displayName: 'Bills',
            color: colors.categories.bills,
            emoji: '🧾',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        charity: {
            id: 'charity',
            displayName: 'Charity',
            color: colors.categories.charity,
            emoji: '🎗',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        investments: {
            id: 'investments',
            displayName: 'Investments',
            color: colors.categories.investment,
            emoji: '🏦',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        education: {
            id: 'education',
            displayName: 'Education',
            color: colors.categories.education,
            emoji: '📚',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        family: {
            id: 'family',
            displayName: 'Family',
            color: colors.categories.family,
            emoji: '👪',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        business: {
            id: 'business',
            displayName: 'Business',
            color: colors.categories.business,
            emoji: '💼',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        income: {
            id: 'income',
            displayName: 'Income',
            color: colors.categories.income,
            emoji: '💰',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        general: {
            id: 'general',
            displayName: 'General',
            color: colors.categories.general,
            emoji: '💸',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        internal: {
            id: 'internal',
            displayName: 'Excluded',
            color: colors.elements.secondary,
            emoji: '↔️',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
        transfer: {
            id: 'transfer',
            displayName: 'Transfer',
            color: colors.categories.transfer,
            emoji: '🔁',
            iconUrl: '',
            whiteBgIconUrl: '',
        },
    }), [colors]);
};
export const useColorOfCategory = () => {
    const colors = useColors();
    const categories = useAppSelector(selectNormalizedCategories);
    const defaultCategories = useCategories();
    const fallback = colors.categories.custom;
    return useCallback((category) => {
        // use its parent category's color if exists
        let cat = category;
        if (cat.parentCategoryId && cat.parentCategoryId !== cat.id) {
            const parent = categories[cat.parentCategoryId];
            if (parent)
                cat = parent;
        }
        if (isDefaultCategory(cat.id)) {
            return defaultCategories[cat.id].color;
        }
        // use its color or a fallback
        const customCategoryColorKey = readColorKeyOfRawCategory(cat);
        return customCategoryColorKey ? colors.categories[customCategoryColorKey] : fallback;
    }, [categories, colors.categories, defaultCategories, fallback]);
};
